/**
 * Check equality of objects including all children
 * @param a
 * @param b
 * @return {boolean} True of the objects are exactly equal, false otherwise
 */
export function deepEquals(a, b) {
    if (a && b && typeof a === 'object' && typeof b === 'object') {
        if (Object.keys(a).length !== Object.keys(b).length) return false;
        for (const key in a) if (!deepEquals(a[key], b[key])) return false;
        return true;
    } else return a === b;
}
